import { Widget, WIDGET_TEXT } from "@gaming/srvg-classes-core";


export class TextWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#textWidget';
        super( options );

        this.name = 'widgettext';
        this.widgetName = options.widgetName || WIDGET_TEXT;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addTextWidget();
        super.handleDomInstantiated();
    }

    /**
     * add text widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addTextWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

}